import React from 'react';
import cn from 'classnames';
import { Link } from 'react-router-dom';

type Props = {
  id: string;
  link: string;
  img: string;
  title: string;
  date: string;
  exclusive_material: boolean;
};

const MaterialsLink = (props: Props) => {
  const { img, link, title, date, exclusive_material } = props;
  return (
    <>
      <Link to={link} className="materials__link">
        <img src={img} alt={title} className="materials__img" />
        {(title && (
          <div className="materials__common">
            <h3
              className="materials__title"
              dangerouslySetInnerHTML={{ __html: title }}
            ></h3>
            <div className="materials__date">{date}</div>
            <span className="materials__more more">
              Читать больше
              <svg className="more__icon">
                <use href="/img/sprite.svg#icons--arrow-right"></use>
              </svg>
            </span>
          </div>
        )) ||
          ''}
      </Link>
      {exclusive_material && (
        <div
          className={cn('tag post-video__tag', {
            exclusive: exclusive_material,
          })}
        >
          {'Эксклюзив'}
        </div>
      )}
    </>
  );
};

export default MaterialsLink;
